<template>
  <div class="import-main">
    <Space wrap>
    </Space>
    <div class="header_top">
      <div class="import_btn">
        导入
        <input type="file" accept=".xls,.xlsx" class="upload_file" @change="readExcel($event)" />
      </div>
    </div>
    <Table :columns="columns" :data="lists" height="500"></Table>
    <div class="submit_box">
      <Poptip confirm title="是否将数据导入列表中?" @on-ok="onClickSubmit" @on-cancel="cancel">
        <Button type="success">提交数据</Button>
      </Poptip>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import XLSX from "xlsx";
import Image from "@/views/device/image.vue";

export default {
  name: "",
  components: {
    Image,
  },
  props: {
    refListTable: {
      type: Function,
    },
  },
  data() {
    return {
      columns: [
        {
          title: "序号",
          key: "no",
          minWidth: 80,
          align: "left",
          copy: true,
        },
        {
          title: "错误描述",
          minWidth: 180,
          align: "left",
          key: "descr",
          viewimage: true,
        },
        {
          title: "住院号",
          key: "patientId",
          minWidth: 120,
          align: "center",
        },
        {
          title: "姓名",
          key: "patientName",
          minWidth: 120,
          align: "center",
        }, {
          title: "预计手术时间",
          key: "operativeTime",
          minWidth: 120,
          align: "center",
        },

      ],
      lists: [],
      oldList: [],
    };
  },
  computed: {},
  created() {
  },
  methods: {
    readExcel(e) {
      // 读取表格文件
      let that = this;
      const files = e.target.files;
      if (files.length <= 0) {
        return false;
      } else if (!/.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$message({
          message: "上传格式不正确，请上传xls或者xlsx格式",
          type: "warning",
        });
        return false;
      } else {
        // 更新获取文件名
        that.upload_file = files[0].name;
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) || []; //生成json表格内容
          that.lists = [];
          // 从解析出来的数据中提取相应的数据
          ws.forEach((item) => {
            // 1.先判断字符串是不是纯数字
            if (!isNaN(parseFloat(item["预计手术时间"]))) {
              //   //2.如果是纯数字 如果数字小于10万 那么就是日期格式 需要进行转换
              if (item["预计手术时间"] < 100000) {
                let time = new Date((item["预计手术时间"] - 25567) * 24 * 3600000 - 5 * 60 * 1000 - 43 * 1000 - 24 * 3600000 - 8 * 3600000)
                let year = time.getFullYear() + '-'
                let month = time.getMonth() + 1 + '-'
                let date = time.getDate() + ''
                item["预计手术时间"] = year + month + date
              }
            }

            //否则直接返回
            that.lists.push({
              no: item["__rowNum__"] + 1,
              patientId: item["住院号"],
              patientName: item["姓名"],
              operativeTime: item["预计手术时间"],

              // state: 2,
            });
          });
          // 给后端发请求
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      e.target.value = "";
    },
    onClickSubmit() {
      if (this.lists.length == 0) {
        this.$Modal.remove();
        return;
      }
      this.$Spin.show(
        {
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                "style": "animation: ani-demo-spin 1s linear infinite",
                props: {
                  type: 'ios-loading',
                  size: 18
                }
              }),
              h('div', 'Loading')
            ])
          }
        });
      $utils.api
        .load(`/admin/system/nursing/listNursing`, this.lists, "POST")
        .then((res) => {
          if (res.code == 200) {
            this.lists = res.data || [];
            this.oldList = res.data || [];
            let arr = res.successTotal || 0;
            $utils.toast.success(`导入成功`);
            this.refListTable();
            this.$Spin.hide()
            this.$Modal.remove();
            $utils.url.go(0);
          }
          if (res.code == 500) {
            this.lists = res.data || [];
            this.oldList = res.data || [];
            this.$Spin.hide()
          }
        })
        .catch((e) => {
          $utils.toast.error("导入异常" + e.message);
          this.$Spin.hide()
        });
    },
    //js XLSX读取 excel 转换日期格式
    getFormatDate_XLSX(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var fractional_day = serial - Math.floor(serial) + 0.0000001;
      var total_seconds = Math.floor(86400 * fractional_day);
      var seconds = total_seconds % 60;
      total_seconds -= seconds;
      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;
      var d = new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
      //得到Date()对象后，便可进行日期格式化了！
      var add0 = (m) => (m < 10 ? "0" + m : m);
      var YYYY = d.getFullYear();
      var MM = add0(d.getMonth() + 1);
      var DD = add0(d.getDate());
      var hh = add0(d.getHours());
      var mm = add0(d.getMinutes());
      var ss = add0(d.getSeconds());
      return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
    },
  },
};
</script>
<style lang="less" scoped>
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.header_top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}

.import_btn {
  width: 60px;
  height: 35px;
  border-radius: 10px;
  background-color: #fb9338;
  text-align: center;
  line-height: 35px;
  position: relative;
  color: #fff;

  .upload_file {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
  }
}

.submit_box {
  // width: 100px;
  float: right;
  margin-top: 20px;
  margin-left: 15px;
}
</style>
